import React from 'react';
import PropTypes from 'prop-types';
import m from 'messages';
import './logoSnippet.scss';
import { usePortal } from 'context';

const LogoSnippet = () => {
    const {
        user: { name, chapels },
    } = usePortal();
    const partnerLogo = chapels[0]?.logoUrl || null;

    return <div className="logo-snippet">{partnerLogo ? <img src={partnerLogo} alt={name} /> : <h2>{name}</h2>}</div>;
};

export default LogoSnippet;
